import { render } from "./instructor-chat.vue?vue&type=template&id=55e1e146"
import script from "./instructor-chat.vue?vue&type=script&lang=js"
export * from "./instructor-chat.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__